import { call, put } from "redux-saga/effects";
import {
  setGuidelinesData,
  setFrequencyOptions,
  setEditGuidelineData,
  clearEditGuidelineData,
  setGuidelineSuccessMessage,
} from "../../StateManagement/Reducers/PreventiveGuidelinesState";
import {
  GetPreventiveGuidelinesApi,
  GetPreventiveFrequencyOptionsApi,
  CreatePreventiveGuidelineApi,
  EditPreventiveGuidelineApi,
  UpdatePreventiveGuidelineApi,
  DeletePreventiveGuidelineApi,
  TogglePreventiveGuidelineStatusApi,
} from "../Apis/PreventiveGuidelinesApi";

const normalizeResponse = (res) => {
  if (Array.isArray(res)) return res[0] || {};
  return res || {};
};

const isSuccess = (res) => {
  const data = normalizeResponse(res);
  const status = String(data?.Status || data?.status || "").toLowerCase();

  return (
    status === "success" ||
    data?.success === true ||
    Number(data?.success) === 1
  );
};

const getResponseData = (res) => {
  const data = normalizeResponse(res);

  if (Array.isArray(data?.Data)) return data.Data;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(res)) return res;

  return [];
};

function* refreshGuidelinesList() {
  const listData = yield call(GetPreventiveGuidelinesApi);
  yield put(setGuidelinesData(getResponseData(listData)));
}

export function* fetchGuidelinesWorker() {
  try {
    yield call(refreshGuidelinesList);
  } catch (error) {
    console.log("Preventive guidelines list error", error);
    yield put(setGuidelinesData([]));
  }
}

export function* fetchFrequencyOptionsWorker() {
  try {
    const data = yield call(GetPreventiveFrequencyOptionsApi);

    if (isSuccess(data)) {
      yield put(setFrequencyOptions(getResponseData(data)));
    } else {
      yield put(setFrequencyOptions([]));
    }
  } catch (error) {
    console.log("Preventive frequency list error", error);
    yield put(setFrequencyOptions([]));
  }
}

export function* createGuidelineWorker(action) {
  try {
    const data = yield call(CreatePreventiveGuidelineApi, action.payload);

    if (isSuccess(data)) {
      yield call(refreshGuidelinesList);
      yield put(setGuidelineSuccessMessage("Guideline created successfully!"));
    }
  } catch (error) {
    console.log("Preventive guideline create error", error);
  }
}

export function* editGuidelineWorker(action) {
  try {
    const data = yield call(EditPreventiveGuidelineApi, action.payload);

    if (isSuccess(data)) {
      const response = normalizeResponse(data);
      yield put(setEditGuidelineData(response.Data || response.data || null));
    }
  } catch (error) {
    console.log("Preventive guideline edit error", error);
  }
}

export function* updateGuidelineWorker(action) {
  try {
    const data = yield call(UpdatePreventiveGuidelineApi, action.payload);

    if (isSuccess(data)) {
      yield call(refreshGuidelinesList);
      yield put(clearEditGuidelineData());
      yield put(setGuidelineSuccessMessage("Guideline updated successfully!"));
    }
  } catch (error) {
    console.log("Preventive guideline update error", error);
  }
}

export function* deleteGuidelineWorker(action) {
  try {
    const data = yield call(DeletePreventiveGuidelineApi, action.payload);

    if (isSuccess(data)) {
      yield call(refreshGuidelinesList);
      yield put(setGuidelineSuccessMessage("Guideline deleted successfully!"));
    }
  } catch (error) {
    console.log("Preventive guideline delete error", error);
  }
}

export function* toggleGuidelineStatusWorker(action) {
  try {
    const data = yield call(TogglePreventiveGuidelineStatusApi, action.payload);

    if (isSuccess(data)) {
      yield call(refreshGuidelinesList);
      yield put(
        setGuidelineSuccessMessage(
          Number(action.payload?.is_active) === 1
            ? "Guideline enabled successfully!"
            : "Guideline disabled successfully!",
        ),
      );
    }
  } catch (error) {
    console.log("Preventive guideline status toggle error", error);
  }
}
